import { Pipe, PipeTransform } from '@angular/core';
import { PlantingSiteDetailDto } from '../../../models/trofaco/plantingSiteDetailDto';

@Pipe({
  name: 'hasSingleDonor'
})
export class HasSingleDonorPipe implements PipeTransform {

    transform(site: PlantingSiteDetailDto): boolean {
        if (site.certificates.length == 0) return false;
        let firstDonor = site.certificates[0];
        let certSum = site.certificates.reduce((previousValue, currentValue) => previousValue + currentValue.count, 0);
        return site.certificates.every(
            value => value.customerId == firstDonor.customerId) && certSum == site.totalTrees;
    }

}
